<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="版本管理(穿山甲专用)"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 线上版本 -->
    <div class="version-item">
      <div class="version-item-title">
        <div class="version-item-title-left">线上版本</div>
        <div class="version-item-title-right">
          <a-button class="version-item-title-right-button" :disabled="!currentVersion.version" @click="touchPreview(currentVersion, 'current', '线上版本')">预览</a-button>
          <!-- <a-button class="version-item-title-right-button" type="primary" @click="touchSubmit">提交审核</a-button> -->
        </div>
      </div>
      <div class="version-item-content">
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">当前版本：</div>
          <div class="version-item-content-item-value">{{ currentVersion.version || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">发布时间：</div>
          <div class="version-item-content-item-value">{{ currentVersion.ctime ? dayjs(currentVersion.ctime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">项目备注：</div>
          <div class="version-item-content-item-value">{{ currentVersion.summary || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">提交用户：</div>
          <div class="version-item-content-item-value">{{ currentVersion.developer_name ? `${currentVersion.developer_name}（${currentVersion.developer_id}）` : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">是否下架：</div>
          <div class="version-item-content-item-value">{{ currentVersion.has_down !== undefined ? (currentVersion.has_down === 1 ? '是' : '否') : '--' }}</div>
        </div>
      </div>
    </div>
    <!-- 审核版本 -->
    <div class="version-item">
      <a-alert v-if="auditVersion.reason" :message="auditVersion.reason" type="error" class="version-item-alert" />
      <div class="version-item-title">
        <div class="version-item-title-left">审核版本</div>
        <div class="version-item-title-right">
          <a-button class="version-item-title-right-button" :disabled="!auditVersion.version" @click="touchPreview(auditVersion, 'audit', '审核版本')">预览</a-button>
          <a-button class="version-item-title-right-button" :disabled="auditVersion.status !== 1" type="primary" @click="touchPublish">发布</a-button>
        </div>
      </div>
      <div class="version-item-content">
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">当前版本：</div>
          <div class="version-item-content-item-value">{{ auditVersion.version || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">创建时间：</div>
          <div class="version-item-content-item-value">{{ auditVersion.ctime ? dayjs(auditVersion.ctime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">项目备注：</div>
          <div class="version-item-content-item-value">{{ auditVersion.summary || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">提交用户：</div>
          <div class="version-item-content-item-value">{{ auditVersion.developer_name ? `${auditVersion.developer_name}（${auditVersion.developer_id}）` : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">是否发布：</div>
          <div class="version-item-content-item-value">{{ auditVersion.has_publish !== undefined ? (auditVersion.has_publish === 1 ? '是' : '否') : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">审核状态：</div>
          <div class="version-item-content-item-value">
            <span v-if="auditVersion.status === 0" style="color: #1890FF">审核中</span>
            <span v-else-if="auditVersion.status === 1" style="color: #389E0D">通过</span>
            <span v-else-if="auditVersion.status === 2" style="color: #FF4D4F">不通过</span>
            <span v-else-if="auditVersion.status === 3" style="color: #FF4D4F">撤回审核</span>
            <span v-else>--</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 灰度版本 -->
    <!-- <div class="version-item">
      <div class="version-item-title">灰度版本</div>
      <div class="version-item-content">
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">当前版本：</div>
          <div class="version-item-content-item-value">{{ grayVersion.version || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">创建时间：</div>
          <div class="version-item-content-item-value">{{ grayVersion.ctime ? dayjs(grayVersion.ctime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">项目备注：</div>
          <div class="version-item-content-item-value">{{ grayVersion.summary || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">提交用户：</div>
          <div class="version-item-content-item-value">{{ grayVersion.developer_name ? `${grayVersion.developer_name}（${grayVersion.developer_id}）` : '--' }}</div>
        </div>
      </div>
    </div> -->
    <!-- 测试版本 -->
    <div class="version-item">
      <div class="version-item-title">
        <div class="version-item-title-left">测试版本</div>
        <div class="version-item-title-right">
          <a-button class="version-item-title-right-button" :disabled="!testVersion.version" @click="touchPreview(testVersion, 'latest', '测试版本')">预览</a-button>
          <a-button class="version-item-title-right-button" :disabled="testVersion.has_audit !== 0" type="primary" @click="touchAudit">提审</a-button>
        </div>
      </div>
      <div class="version-item-content">
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">当前版本：</div>
          <div class="version-item-content-item-value">{{ testVersion.version || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">创建时间：</div>
          <div class="version-item-content-item-value">{{ testVersion.ctime ? dayjs(testVersion.ctime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">项目备注：</div>
          <div class="version-item-content-item-value">{{ testVersion.summary || '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">提交用户：</div>
          <div class="version-item-content-item-value">{{ testVersion.developer_name ? `${testVersion.developer_name}（${testVersion.developer_id}）` : '--' }}</div>
        </div>
        <div class="version-item-content-item">
          <div class="version-item-content-item-title">是否提审：</div>
          <div class="version-item-content-item-value">{{ testVersion.has_audit !== undefined ? (testVersion.has_audit == 1 ? '是' : '否') : '--' }}</div>
        </div>
      </div>
    </div>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
  <CsjQrcode ref="RefQrcode" />
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message, Modal } from 'ant-design-vue'
import Loading from '@/components/Loading'
import CsjQrcode from './CsjQrcode'
import { csjVersionList, csjVersionAudit, csjVersionRelease, csjVersionPreview } from '@/api/system'
import Pub from '@/utils/public'
import dayjs from 'dayjs'

// emit
const emit = defineEmits(['success'])
// 二维码实例
const RefQrcode = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 线上版本
let currentVersion = ref({})
// 审核版本
let auditVersion = ref({})
// 灰度版本
let grayVersion = ref({})
// 测试版本
let testVersion = ref({})

// 打开抽屉
function showDrawer (params) {
  // 项目id
  id.value = params.id
  // 展开
  visible.value = true
  // 获取版本信息
  getVersionInfo()
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    id.value = undefined
    currentVersion.value = {}
    auditVersion.value = {}
    grayVersion.value = {}
    testVersion.value = {}
    visible.value = false

  }
}

// 获取版本信息
function getVersionInfo () {
  isLoading.value = true
  csjVersionList({
    project_id: id.value
  }).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      console.log(data);
      currentVersion.value = data['current'] || {}
      auditVersion.value = data['audit'] || {}
      // grayVersion.value = data['gray'] || {}
      testVersion.value = data['latest'] || {}
    } else {
      message.error(res.message)
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 发布
function touchPublish () {
  Modal.confirm({
    title: '确定发布吗？',
    onOk: () => {
      isLoading.value = true
      csjVersionRelease({
        project_id: id.value,
      }).then(res => {
        isLoading.value = false
        const { code, data } = res
        if (code === 0) {
          if (data.err_no === 0) {
            message.success('提审成功')
            getVersionInfo()
          } else {
            message.error(data.err_msg)
          }
        } else {
          message.error(res.message)
        }
      }).catch(() => {
        isLoading.value = false
      })
    }
  })
}

// 提审
function touchAudit () {
  Modal.confirm({
    title: '确定提审吗？',
    onOk: () => {
      isLoading.value = true
      csjVersionAudit({
        project_id: id.value,
      }).then(res => {
        isLoading.value = false
        const { code, data } = res
        if (code === 0) {
          if (data.err_no === 0) {
            message.success('提审成功')
            getVersionInfo()
          } else {
            message.error(data.err_msg)
          }
        } else {
          message.error(res.message)
        }
      }).catch(() => {
        isLoading.value = false
      })
    }
  })
}

// 预览
function touchPreview (params, type, typeString) {
  isLoading.value = true
  csjVersionPreview({
    project_id: id.value,
    version: type
  }).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      if (data.err_no === 0) {
        RefQrcode.value.showModal({
          qrcodeUrl: data.data.qr_code_url,
          version: `${params.version}（${typeString}）`
        })
      } else {
        message.error(data.err_msg)
      }
    } else {
      message.error(res.message)
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.version-item {
  width: 100%;
  padding: 20px;
  background-color: #F7F7F7;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  &-alert {
    margin-bottom: 20px;
  }
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-left {
      font-size: 20px;
      font-weight: 600;
    }
    &-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      &-button {
        margin-left: 10px;
      }
    }
  }
  &-content {
    margin-top: 12px;
    &-item {
      margin-top: 4px;
      color: #787A7C;
      display: flex;
      align-items: center;
      &-title {
        font-size: 14px;
        width: 70px;
        flex-shrink: 0;
      }
      &-value {
        font-size: 14px;
        color: #1A1D20;
      }
    }
  }
}
.version-item:not(:first-child) {
  margin-top: 20px;
}
</style>